var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"donut-chart"}},[_c('apexchart',{ref:"donutChart",attrs:{"type":"donut","options":_vm.chartOptions,"series":_vm.chartSeries}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }